import styled from 'styled-components'

import { ResponsiveImage, focusOutline, fromMd } from '@syconium/little-miss-figgy'

import { hashPrefixed } from '../../../../../lib/utils/color'

export const IconButton = styled.button<{
  isSelected: boolean
}>`
  border: 1px solid ${o => (o.isSelected ? 'black' : o.theme.color.deprecated.gray.light)};
  border-radius: 4px;
  height: ${o => o.theme.spacing(13)};
  outline: none;
  padding: 2px;
  width: ${o => o.theme.spacing(13)};
  margin-inline-end: ${o => o.theme.spacing(3)};
  margin-bottom: ${o => o.theme.spacing(3)};

  ${fromMd} {
    height: ${o => o.theme.spacing(16)};
    width: ${o => o.theme.spacing(16)};
    margin-inline-end: 7px;
    margin-bottom: 7px;
  }

  ${focusOutline}
`

export const StyledResponsiveImage = styled(ResponsiveImage)<{
  backgroundColor?: string
}>`
  background: ${o => hashPrefixed(o.backgroundColor)};
  box-sizing: border-box;
  height: 100%;
  object-fit: cover;
  font-family: 'object-fit: cover';
  padding: 2px;
`
